import { render, staticRenderFns } from "./LayoutEdit.vue?vue&type=template&id=6cf1495c&"
import script from "./LayoutEdit.vue?vue&type=script&lang=js&"
export * from "./LayoutEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports